export enum VideoType {
    WEIGHT = "WEIGHT",
    HEIGHT = "HEIGHT",
    CALIBRATION = "CALIBRATION",
    OTHER = "OTHER"
}